import { createSlice } from "@reduxjs/toolkit";

export const add_Client_id_propriety_id = (payload) => async (dispatch) => {
  try {
    dispatch(
      addData({
        client_id: payload.client_id,
        propriety_id: payload.propriety_id,
      })
    );
  } catch (error) {
    console.log();
  }
};

export const contratsReducer = createSlice({
  name: "contrat",
  initialState: {
    client_id: null,
    propriety_id: null,
    togglePrintContrat: false,
  },
  reducers: {
    addData: (state, action) => {
      return {
        ...state,
        client_id: action.payload.client_id,
        propriety_id: action.payload.propriety_id,
      };
    },
    handleTogglePrintContrat: (state, action) => {
      console.log("handleTogglePrintContrat", action);
      state.togglePrintContrat = action.payload;
    },
  },
});

export const { addData, handleTogglePrintContrat } = contratsReducer.actions;
export default contratsReducer.reducer;
